export default {
  activeEntity: state => {
    return state.active_entity
  }
}
